import { render, staticRenderFns } from "./ResizableContainer.vue?vue&type=template&id=10fe22de&scoped=true&"
import script from "./ResizableContainer.vue?vue&type=script&lang=ts&"
export * from "./ResizableContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ResizableContainer.vue?vue&type=style&index=0&id=10fe22de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fe22de",
  null
  
)

export default component.exports